let getters = {
    token: state => {
        return state.token
    }
}

export default getters
